import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import request from '../../helpers/request';
import purchaseSuggestionConfig from './config/purchaseSuggestionConfig';
import setViewTitle from '../../helpers/setViewTitle';
import CommentsWidget from '../common/CommentsWidget';
import Widget from '../common/Widget';
import {AdornedInput} from "../common/Forms";

var PurchaseSuggestionReadOnly = createReactClass({

  getInitialState() {
    return {
      suggestion: {
        lines: []
      }
    };
  },

  componentWillMount() {
    setViewTitle('Bestellvorschlag');
  },

  componentDidMount() {
    request.get({
      url: purchaseSuggestionConfig.apiUrl + this.props.match.params.suggestionId,
      success: suggestion => {
        if (this.isMounted()) {
          this.setState({
            suggestion: suggestion
          });
        }
      }
    });
  },

  render() {
    var displayLines = this.state.suggestion.lines.map(line =>
      <tr key={line.itemId}>
          <td>{line.itemName}</td>
          <td>{line.vendorName}</td>
          <td>{line.purchaseUnitQuantity}</td>
          <td>{line.purchaseUnitName}</td>
          <td>{line.lineNetPrice}</td>
      </tr>
    );

    const title = this.state.suggestion.orderWithoutStorage ? 'Zu genehmigender Bestellvorschlag ohne Lagerführung' : 'Zu genehmigender Bestellvorschlag';
    return (
        <div>
          <div className="row">
            <Widget title={title} bodyClassName="min-height-auto">
              {
                this.state.suggestion.orderWithoutStorage &&
                <div style={{ padding: '10px' }}>
                  <strong style={{ marginRight: '.5em' }}>Bestellsumme:</strong>
                  <span>€ {this.state.suggestion.price}</span>
                </div>
              }
              {!this.state.suggestion.orderWithoutStorage &&
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                    <tr>
                      <th>Artikel</th>
                      <th>Lieferant</th>
                      <th>Bestellmenge</th>
                      <th>Bestelleinheit</th>
                      <th>Preis</th>
                    </tr>
                    </thead>
                    <tbody>
                    {displayLines}
                    </tbody>
                  </table>
                </div>
              }
              <div className="widget-footer">
                <Link to="purchasesuggestions/overview" className="btn btn-default">Zurück</Link>
              </div>
            </Widget>
          </div>
          <div className="row">
            <CommentsWidget
              apiUrl={`purchasesuggestions/${this.props.match.params.suggestionId}/comments`}
              containerClassName="col-md-12"
              claim={false}
            />
          </div>
        </div>
    );
  }

});

export default PurchaseSuggestionReadOnly;



// WEBPACK FOOTER //
// ./src/components/purchasesuggestions/PurchaseSuggestionReadOnly.js